import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

const TextWrapper = styled.div`
  width: 100%;

  margin-top: 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  color: white;

  > .h3 {
    font-size: 24px;
    font-weight: 700;
  }

  > .p {
    margin-top: 0.5rem;

    font-size: 18px;
    font-weight: 400;
  }
`;

export default function MobileModal() {
  return (
    <Modal size="full" isOpen={true} onClose={() => {}}>
      <ModalOverlay style={{ background: "rgba(0, 0, 0, 0.76)" }} />
      <ModalContent style={{ background: "transparent", boxShadow: "unset" }}>
        <ModalBody
          css={css`
            width: 100%;

            padding: 2rem 0;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img {
              max-width: 96px;
              width: 100%;
            }
          `}
        >
          <img src="./hand-phone.png" alt="Phone" />

          <TextWrapper>
            <div className="h3">Please rotate your device</div>
            <div className="p">
              BerserkerMail is best experienced with your device in portrait
              mode.
            </div>
          </TextWrapper>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
